import React from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertTriangle } from 'lucide-react';
import SEO from './components/SEO';

const NotFound = () => {
    return (
        <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4 text-center">
            <SEO
                title="Sidan hittades inte - Noctra"
                description="Sidan du söker finns inte."
            />

            <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-slate-100 max-w-lg w-full">
                <div className="w-20 h-20 bg-purple-50 rounded-full flex items-center justify-center mx-auto mb-6">
                    <AlertTriangle className="w-10 h-10 text-purple-600" />
                </div>

                <h1 className="text-4xl font-bold text-slate-900 mb-4">404</h1>
                <h2 className="text-xl font-semibold text-slate-700 mb-4">Sidan hittades inte</h2>

                <p className="text-slate-500 mb-8">
                    Hoppsan! Sidan du letar efter verkar ha flyttat eller finns inte längre.
                </p>

                <Link
                    to="/"
                    className="inline-flex items-center justify-center px-6 py-3 bg-slate-900 text-white font-bold rounded-xl hover:bg-slate-800 transition-colors w-full sm:w-auto"
                >
                    <Home className="w-4 h-4 mr-2" />
                    Tillbaka till startsidan
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
